import { useLayoutEffect } from 'react';

export default function useExpandedDetailScroll(detailId) {
    useLayoutEffect(() => {
        if (!detailId || !window.matchMedia('(max-width: 800px)').matches) return;

        const detail = document.getElementById(detailId);
        const button = document.querySelector(`[aria-controls="${detailId}"]`);
        if (!detail || !button) return;

        // Measure after the previous panel has collapsed and the new one has opened.
        const viewport = window.visualViewport;
        const viewportTop = viewport?.offsetTop ?? 0;
        const viewportBottom = viewportTop + (viewport?.height ?? window.innerHeight);
        const headerBottom = document.querySelector('.ef-header')?.getBoundingClientRect().bottom ?? 0;
        const visibleTop = Math.max(viewportTop, headerBottom) + 16;
        const firstItem = detail.querySelector('li') ?? detail;
        const contentTop = firstItem.getBoundingClientRect().top;
        const lineHeight = parseFloat(window.getComputedStyle(firstItem).lineHeight) || 24;
        const buttonTop = button.getBoundingClientRect().top;

        if (buttonTop >= visibleTop && contentTop + lineHeight <= viewportBottom - 16) return;

        // Keep the control in view where possible, with room for the first line of details.
        const targetTop = Math.max(buttonTop, contentTop + lineHeight - (viewportBottom - visibleTop - 16));
        window.scrollBy({ top: targetTop - visibleTop, behavior: 'instant' });
    }, [detailId]);
}
